import { regex } from './regex'

const { extractYoutubeLink } = regex

export const extractVideoId = (url) => {
  const match = url.match(extractYoutubeLink)
  return match ? match[1] : null
}
